import { render, staticRenderFns } from "./changeBox.vue?vue&type=template&id=141fd0f8&scoped=true"
import script from "./changeBox.vue?vue&type=script&lang=js"
export * from "./changeBox.vue?vue&type=script&lang=js"
import style0 from "./changeBox.vue?vue&type=style&index=0&id=141fd0f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141fd0f8",
  null
  
)

export default component.exports